<template>
  <div class="full-chat-w single-page-container">
    <div class="content-box col-sm-8 col-xs-12">
      <div class="element-wrapper">
        <h6 class="element-header">Add Copydesk Import</h6>
        <div class="element-box p-10">
          <form id="addImportForm">

            <div class="form-group row">
              <label class="col-form-label col-sm-4" for>CSV File</label>
              <div class="col-sm-8">
                <input type="file" id="import_file" name="import_file" required />
              </div>
            </div>

            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Channel</label>
                <div class="col-sm-8">
                    <label for=""> </label>
                    <select class="form-control" name="id_channel">
                        <option value="">Select a channel</option>
                        <option v-for="channel in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
                    </select>
                </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-4 col-form-label">Language</label>
                <div class="col-sm-8">
                    <label for=""> </label>
                    <select class="form-control" name="id_language">
                        <option value="">Select a language</option>
                        <option v-for="language in languages" :value="language.id_language">{{language.name}}</option>
                    </select>
                </div>
            </div>

            <div class="form-buttons-w">
              <button class="btn btn-primary" type="button" @click="addImport()">Import</button>
              <button class="btn btn-primary" type="button" @click="formMode = 'view'">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="content-panel col-sm-4 col-xs-hidden middle">
      <div class="content-panel-close">
        <i class="os-icon os-icon-close"></i>
      </div>
      <div class="element-wrapper">
        <h6 class="element-header">Guide</h6>
        <div class="element-box-tp">
          <div class="todo-list">
            <a class="todo-item">
              <div class="ti-info">
                <div class="ti-header">File must be UTF-8 encoded CSV</div>
              </div>
            </a>
            <a class="todo-item">
              <div class="ti-info">
                <div class="ti-header">Language is required</div>
              </div>
            </a>
            <a class="todo-item">
              <div class="ti-info">
                <div class="ti-header">Channel is required</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AddSessionForm from '@/components/common/Forms/AddSession'
import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions],
  components: { AddSessionForm },
  data () {
    return {
      sideBarContent: 'users',
      channels: '',
      categories: '',
      users: '',
      userSearch: '',
      filteredUsers: '',
      selectedUsers: []
    }
  },
  mounted () {
    this.getFormParameters()
  },
  methods: {
    getFormParameters () {
      var self = this

      const url = '/photodesk/session/add/helper'
      this.$http
        .get(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.channels = response.data.channels
          self.languages = response.data.languages
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: error.response.data || 'Something went wrong',
            show: true
          })
        })
    },
    addImport: function () {
      var self = this

      const url = '/copydesk/io/import'

      var form = document.getElementById('addImportForm')
      let data = new FormData(form)

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.$store.dispatch('updateToast', {
            text: 'Import created',
            show: true
          })
          self.$router.push('/copydesk/imports')
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text:
              (error.response && error.response.data.error) ||
              'Something went wrong',
            show: true
          })
        })
    }
  }
}
</script>

<style scoped>
.single-page-container {
  padding: 20px;
}
.content-panel {
  padding: 1rem;
}
</style>
